export default {
  title: {
    en: 'Give the gift of the scent',
  },
  subTitle: {
    en: 'A Scentbird subscription is the gift that keeps on giving! For her or for him',
  },
  buttonTitle: {
    en: 'Buy gift now',
  },
}
